var map = {
	"./arrow.svg": "864f",
	"./arrow_down.svg": "e19c",
	"./arrow_left.svg": "deed",
	"./arrow_right.svg": "a35d",
	"./arrow_up.svg": "099b",
	"./banks.svg": "1293",
	"./compass.svg": "7534",
	"./contacts_mail.svg": "1606",
	"./contacts_phone.svg": "584f",
	"./contacts_time.svg": "611a",
	"./cybeam.svg": "b7a2",
	"./download.svg": "77d6",
	"./facebook.svg": "6617",
	"./filter.svg": "1d91",
	"./floor.svg": "6784",
	"./gas_station.svg": "5e6f",
	"./hat.svg": "b219",
	"./hospitals.svg": "d891",
	"./instagram.svg": "c3f2",
	"./kindergartens.svg": "4b32",
	"./layout.svg": "05a8",
	"./layout_list.svg": "e89c",
	"./logo.svg": "acef",
	"./nav.svg": "1815",
	"./ok.svg": "51f2",
	"./parks.svg": "7825",
	"./phone.svg": "fda0",
	"./restaurants.svg": "11ea",
	"./roller.svg": "4684",
	"./security.svg": "b7f6",
	"./share.svg": "3ac8",
	"./shops.svg": "a975",
	"./tagree.svg": "032f",
	"./tile.svg": "9dce",
	"./twitter.svg": "b6c1",
	"./video.svg": "9476",
	"./x.svg": "b66d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c64";